"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M12 3 2 21h20zm1 5.92L18.6 19H13zm-2 0V19H5.4z"
}), 'Details');